import { useCallback, useEffect, useRef, useState } from "react";

const MENU_CLOSE_MS = 200; // 모바일 메뉴 접힘 시간 (motion.css 의 ibmMenuOut 과 같게)

// 공통 헤더: 로고 · 메뉴 6개(BUSINESS 하위 메뉴) · 지역 표기 · 모바일 햄버거 메뉴
// 스크롤하면 옅은 그림자(is-scrolled), 모바일 메뉴는 펼치고 접을 때 짧게 움직인다.
export default function Header({ currentKey }) {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const closeTimer = useRef(null);
  const openRef = useRef(false);
  useEffect(() => {
    openRef.current = open;
  }, [open]);

  const closeMenu = useCallback((immediate = false) => {
    clearTimeout(closeTimer.current);
    if (!openRef.current) return;
    if (immediate) {
      setClosing(false);
      setOpen(false);
      return;
    }
    setClosing(true);
    closeTimer.current = setTimeout(() => {
      setClosing(false);
      setOpen(false);
    }, MENU_CLOSE_MS);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 960) closeMenu(true);
    };
    const onKey = (e) => {
      if (e.key === "Escape") closeMenu();
    };
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("keydown", onKey);
    onScroll();
    return () => {
      clearTimeout(closeTimer.current);
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("keydown", onKey);
    };
  }, [closeMenu]);

  const toggle = () => {
    if (open && !closing) closeMenu();
    else {
      clearTimeout(closeTimer.current);
      setClosing(false);
      setOpen(true);
    }
  };
  const expanded = open && !closing;
  const cur = (key) => (currentKey === key ? { className: "is-current", "aria-current": "page" } : {});

  return (
    <header className={"ib-header" + (scrolled ? " is-scrolled" : "")} id="top">
      <div className="ib-wrap ib-header__inner">
        <a className="ib-logo" href="/" aria-label="INBA Thailand 홈으로">
          <img src="/assets/img/common/inba_logo.png" alt="INBA International Bridge & Access" width="144" height="43" />
        </a>
        <nav
          className={"ib-nav" + (open ? " is-open" : "") + (closing ? " is-closing" : "")}
          id="ibNav"
          aria-label="주요 메뉴"
          data-lenis-prevent=""
          onClick={(e) => {
            if (e.target.closest("a")) closeMenu();
          }}
        >
          <a href="/" {...cur("home")}>HOME</a>
          <a href="/about" {...cur("about")}>ABOUT INBA</a>
          <div className="ib-drop">
            <a href="/business" {...cur("business")}>BUSINESS</a>
            <div className="ib-drop__menu">
              <a href="/business#trade">TRADE</a>
              <a href="/business#digital">DIGITAL</a>
              <a href="/business#events">EVENTS</a>
            </div>
          </div>
          <a href="/portfolio" {...cur("portfolio")}>PORTFOLIO</a>
          <a href="/brands" {...cur("brands")}>OUR BRANDS</a>
          <a href="/contact" {...cur("contact")}>CONTACT</a>
        </nav>
        <span className="ib-region">KOREA × THAILAND</span>
        <button
          type="button"
          className="ib-burger"
          aria-controls="ibNav"
          aria-expanded={expanded}
          aria-label={expanded ? "메뉴 닫기" : "메뉴 열기"}
          onClick={toggle}
        >
          <span className="ib-burger__box">
            <span />
            <span />
            <span />
          </span>
        </button>
      </div>
    </header>
  );
}
